export default IconCoffin => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-coffin" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 3l-2 6l2 12h6l2 -12l-2 -6z" />
  <path d="M10 7v5" />
  <path d="M8 9h4" />
  <path d="M13 21h4l2 -12l-2 -6h-4" />
</svg>`;